$(() => {
    const postToCart = (updateModel, successMessage) => {
        $.post({
            url: `/api/commerce/cart`,
            data: updateModel,
            dataType: `json`,
            contentType: `application/json`
        }).done((data) => {
            toastMessage(successMessage);
            updateCartIcon(data.payload.totalCount);
        });
    };
    const toastMessage = (htmlMessage) => {
        $('#toast-message').html(htmlMessage);
        $('#cart-updated-toast').toast('show');
    };
    const addBookMessage = (quantity) =>
        `<strong>${quantity}</strong> exemplar ${
            parseInt(quantity) > 1 ? 'tillagda' : 'tillagt'
        } i varukorgen.`;
    const updateCartIcon = (totalCount) => {
        $('.shopping-cart-top-link .shopping-cart-icon__count').text(totalCount);
        if (totalCount == 0) {
            $('.shopping-cart-top-link .shopping-cart-icon').addClass('shopping-cart-icon--empty');
        } else {
            $('.shopping-cart-top-link .shopping-cart-icon').removeClass(
                'shopping-cart-icon--empty'
            );
        }
    };
    const getUpdateModel = (type, variationCode, quantity) => {
        const model = {
            isCheckout: false,
            items: {
                [variationCode]: {}
            }
        };
        switch (type) {
            case 'book':
                model.items[variationCode]['quantity'] = quantity;
                break;
            default:
                model.items[variationCode]['quantity'] = 1;
                break;
        }
        return JSON.stringify(model);
    };

    const $forms = $(`.add-to-cart-form`);
    if (!$forms.length) return;

    for (var i = 0; i < $forms.length; i++) {
        const formAccessor = (name) => $($forms[i]).find(`input[name="${name}"]`).val();
        const type = $forms[i].dataset.productType;
        const variationCode = formAccessor('code');
        const quantity = parseInt(formAccessor('quantity'));

        const cartUpdatedToast = $('#cart-updated-toast');
        cartUpdatedToast.toast({ delay: 2622 });

        $($forms[i]).on(`submit`, (event) => {
            event.stopPropagation();
            event.preventDefault();

            if (window.productFields && window.dataLayer) {
                const productField = window.productFields.find(
                    (x) => x.id === variationCode.toUpperCase()
                );

                if (productField) {
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push({
                        event: 'addToCart',
                        ecommerce: {
                            currencyCode: `${productField.currencyCode}`,
                            add: {
                                products: [
                                    {
                                        name: `${productField.name}`,
                                        id: `${productField.id}`,
                                        price: `${productField.price}`,
                                        category: `${productField.category}`,
                                        variant: `${productField.variant}`,
                                        quantity: productField.quantity
                                    }
                                ]
                            }
                        }
                    });
                }
            }

            const updateModel = getUpdateModel(type, variationCode, quantity);
            if (type === 'book') {
                const bookAddMessage = addBookMessage(quantity);
                postToCart(updateModel, bookAddMessage);
            }
        });
    }
});
